import ChannelItem from './channelItem';

export default ChannelItem;
